export default __webpack_public_path__ + "e1e71ffea5ae0ea0bf76e6f5cfa6970d.png";